export function canEditV5075SnWhitelist(mode) {
  return String(mode || '').trim().toLowerCase() === 'sn';
}

export function getV5075SnWhitelistPlaceholder(mode) {
  return canEditV5075SnWhitelist(mode)
    ? '输入接头 SN'
    : '切换到“指定 SN”后可添加';
}

export function normalizeAuth800ReleaseMode(value) {
  return String(value || '').trim().toLowerCase() === 'all' ? 'all' : 'tw';
}

export function isAuth800ReleaseAll(value) {
  return normalizeAuth800ReleaseMode(value) === 'all';
}

export function auth800ReleaseModeFromSwitch(enabled) {
  return enabled ? 'all' : 'tw';
}
